import { render, staticRenderFns } from "./AcceptOrder.vue?vue&type=template&id=6d957a62"
import script from "./AcceptOrder.vue?vue&type=script&lang=js"
export * from "./AcceptOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports